import React, { FC } from 'react';

import styles from './PaymentIcon.module.scss';

interface Props {
  className?: string;
}

const PaymentIcon: FC<Props> = ({ className }) => {
  return (
    <svg className={className}
         xmlns="http://www.w3.org/2000/svg"
         width="168"
         height="184"
         fill="none"
         viewBox="0 0 168 184">
      <path className={styles.top}
            d="M44 25a5 5 0 0 1 5-5h70a5 5 0 0 1 5 5v85.5H44V25Z" />
      <path className={styles.background}
            d="M57.5 33.5h53v54h-53v-54Z" />
      <path className={styles.background}
            d="M90.5 96.5h16v7h-16v-7Z" />
      <ellipse className={styles.circle}
               cx="84"
               cy="162.5"
               rx="84"
               ry="21.5" />
      <path className={styles.skeleton}
            fillRule="evenodd"
            d="M120 20H48a4 4 0 0 0-4 4v132h80V24a4 4 0 0 0-4-4Zm-72-2a6 6 0 0 0-6 6v134h84V24a6 6 0 0 0-6-6H48Z"
            clipRule="evenodd" />
      <path className={styles.skeleton}
            fillRule="evenodd"
            d="M110.5 33.5h-53v54h53v-54Zm-55-2v58h57v-58h-57Z"
            clipRule="evenodd" />
      <path className={styles.skeleton}
            fillRule="evenodd"
            d="M106.5 96.5h-16v7h16v-7Zm-18-2v11h20v-11h-20Z"
            clipRule="evenodd" />
      <path className={styles.skeleton}
            fillRule="evenodd"
            d="M124.5 112.5h-81v-2h81v2Z"
            clipRule="evenodd" />
      <path className={styles.skeleton}
            d="M63.5 95c0 .8-.9 1.5-2 1.5s-2-.7-2-1.5.9-1.5 2-1.5 2 .7 2 1.5Z" />
      <path className={styles.skeleton}
            d="M69.5 95c0 .8-.9 1.5-2 1.5s-2-.7-2-1.5.9-1.5 2-1.5 2 .7 2 1.5Z" />
      <path className={styles.skeleton}
            d="M75.5 95c0 .8-.9 1.5-2 1.5s-2-.7-2-1.5.9-1.5 2-1.5 2 .7 2 1.5Z" />
      <path className={styles.skeleton}
            d="M63.5 100c0 .8-.9 1.5-2 1.5s-2-.7-2-1.5.9-1.5 2-1.5 2 .7 2 1.5Z" />
      <path className={styles.skeleton}
            d="M69.5 100c0 .8-.9 1.5-2 1.5s-2-.7-2-1.5.9-1.5 2-1.5 2 .7 2 1.5Z" />
      <path className={styles.skeleton}
            d="M75.5 100c0 .8-.9 1.5-2 1.5s-2-.7-2-1.5.9-1.5 2-1.5 2 .7 2 1.5Z" />
      <path className={styles.button}
            d="M63.5 105c0 .8-.9 1.5-2 1.5s-2-.7-2-1.5.9-1.5 2-1.5 2 .7 2 1.5Z" />
      <path className={styles.skeleton}
            d="M69.5 105c0 .8-.9 1.5-2 1.5s-2-.7-2-1.5.9-1.5 2-1.5 2 .7 2 1.5Z" />
      <path className={styles.button}
            d="M75.5 105c0 .8-.9 1.5-2 1.5s-2-.7-2-1.5.9-1.5 2-1.5 2 .7 2 1.5Z" />
      <path className={styles.star}
            fillRule="evenodd"
            d="M30.3 31c-.7 0-1.2.6-1.2 1.3V36h-3.8a1.3 1.3 0 0 0 0 2.5H29v3.8a1.3 1.3 0 1 0 2.5 0v-3.8h3.8a1.3 1.3 0 0 0 0-2.5h-3.8v-3.7c0-.7-.6-1.3-1.3-1.3Z"
            clipRule="evenodd" />
      <path className={styles.star}
            fillRule="evenodd"
            d="M143.3 105c-.7 0-1.2.6-1.2 1.3v3.7h-3.8a1.3 1.3 0 1 0 0 2.5h3.8v3.8a1.3 1.3 0 0 0 2.5 0v-3.8h3.8a1.3 1.3 0 0 0 0-2.5h-3.8v-3.7c0-.7-.6-1.3-1.3-1.3Z"
            clipRule="evenodd" />
      <path className={styles.roundStar}
            strokeWidth="2"
            d="M50.1 5a4 4 0 0 1-4 4A4 4 0 0 1 42 5a4 4 0 0 1 4-4 4 4 0 0 1 4.1 4Z" />
      <path className={styles.roundStar}
            strokeWidth="2"
            d="M142.1 80a4 4 0 0 1-4 4 4 4 0 0 1-4.1-4 4 4 0 0 1 4-4 4 4 0 0 1 4.1 4Z" />
      <path className={styles.roundStar}
            strokeWidth="2"
            d="M27 17.5c0 .8-.6 1.5-1.5 1.5-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5c.9 0 1.6.7 1.6 1.5Z" />
      <path className={styles.roundStar}
            strokeWidth="2"
            d="M133 98.5c0 .8-.6 1.5-1.5 1.5-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5c.9 0 1.6.7 1.6 1.5Z" />
      <path className={styles.background}
            d="M44 114.5h80V158H44v-43.5Z" />
    </svg>
  );
};

export default PaymentIcon;
